import React, { FC, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import {
	fetchDisputesCardBrands,
	fetchDisputesManagementSystems, fetchKountStatusCodes,
	setPagination,
	setSorting
} from '../../../store/disputes/actions/disputes';
import { fetchDisputeQueueArchivedData } from '../../../store/disputes/actions/dispute-queues';
import { useDisputesContext } from '../../../store/disputes/disputes-context';
import { TablesNames } from '../../../store/tables/tables-context';
import { IModalWindow, ModalWindow } from '../../modal/ModalWindow';
import { Table } from '../../table/Table';
import { useLocation } from 'react-router';

export const DisputesArchived: FC = () => {
	const isMounted = useRef(false);
	const { search } = useLocation();

	const { disputesContextState, dispatch } = useDisputesContext();

	const {
		disputes,
		isDisputesLoading,
		pageSize,
		pageNumber,
		sorting,
		totalItemCount,
	} = disputesContextState;

	const [modalState, setModalState] = useState<IModalWindow>({
		isOpen: false
	});

	const closeModal = (): void => setModalState(prev => ({ ...prev, isOpen: false }));

	// const handleClick = (id: string): void => {
	// 	setModalState({
	// 		isOpen: true,
	// 		modalTitle: 'Unarchive dispute',
	// 		content: (
	// 			<>
	// 				<div className="fs-5">You are going to unarchive dispute.</div>
	// 				<div className="fs-5">Are you sure?</div>
	// 			</>
	// 		),
	// 		minHeight: 100,
	// 		confirmButtonText: 'Unarchive',
	// 		onConfirm: async () => {
	// 			try {
	// 				await unarchiveDispute(id);
	// 				await fetchDisputeQueueArchivedData(dispatch, disputesContextState);
	// 				closeModal();
	// 			} catch (e) {
	// 				console.log('error', e.response);
	// 			}
	// 		},
	// 		onCancel: closeModal
	// 	});
	// };

	useEffect(() => {
		void fetchDisputesManagementSystems(dispatch);
		void fetchKountStatusCodes(dispatch);
		void fetchDisputesCardBrands(dispatch);
		void fetchDisputeQueueArchivedData(dispatch, disputesContextState);
	}, []);

	useEffect(() => {
		if (disputes === null || !isMounted.current) return;
		void fetchDisputeQueueArchivedData(dispatch, disputesContextState);
	}, [pageSize, pageNumber]);

	useEffect(() => {
		if (!isMounted.current) {
			isMounted.current = true;
		}
	}, []);

	const rowActions = (rowData): JSX.Element => {
		const path = `/disputes/queue-item/${rowData?.original?.id}`;
		return (
			// <div className="text-center">
			// 	<ButtonComponent
			// 		buttonType={BUTTON_TYPE.WHITE}
			// 		buttonName="Unarchive"
			// 		additionalClass="no-letter-spacing fs-7 py-1 ps-2 pe-3 d-block mx-auto"
			// 		onButtonClick={(): void => handleClick(rowData?.original?.id)}
			// 	/>
			// </div>
			<div className="text-center">
				<Link
					to={path}
					className="text-muted fs-7 fw-bolder"
					state={{ search }}
				>
					View
				</Link>
			</div>
		);
	};

	return (
		<>
			{/*<DisputesArchiveFilterSection/>*/}

			<Table
				name={TablesNames.disputesArchivedTableData}
				data={disputes ?? []}
				sorting={sorting}
				pageNumber={pageNumber}
				pageSize={pageSize}
				totalItemCount={totalItemCount}
				isLoading={isDisputesLoading}
				setSorting={(value): void => setSorting(dispatch, value)}
				setPagination={(value): void => setPagination(dispatch, disputesContextState, value)}
				// toolbarCustomAction={
				// 	<ExportCSVButton
				// 		orderTotalItemCount={totalItemCount}
				// 		isExportCSVLoading={isDisputesExportLoading}
				// 		exportCSV={async (): Promise<void> => await exportCSVDisputes(dispatch, disputesContextState, chosenMerchant)}
				// 	/>
				// }
				enableRowActions={true}
				rowActions={rowActions}
				actionColumnsSize={50}
				// renderDetailPanel={DisputesDetailPanel}
			/>
			<ModalWindow
				{...modalState}
				onClose={closeModal}
			/>
		</>
	);
};
